import React, { useEffect } from "react";
import { IAppPropsWithRoute } from "../../common/types";
import { withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showNavbar } from "../../store/modules/appStateSlice";
import AddEditReasonsForRescheduleWidget from "./AddEditReasonsForRescheduleWidget";

interface AddEditReasonsForReschedulePageProps extends IAppPropsWithRoute {}

const AddEditReasonsForReschedulePage = (
  props: AddEditReasonsForReschedulePageProps
): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showNavbar(true));
  }, [dispatch]);

  const Id = props.match.params.Id;

  return <AddEditReasonsForRescheduleWidget Id={Id}/>;
};

export default React.memo(withRouter(AddEditReasonsForReschedulePage));
